import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';

import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-tga-veldwaarnemingen-evaluation',
  templateUrl: './tga-veldwaarnemingen-evaluation.component.html',
  imports: [PowerbiReportComponent],
})
export class TgaVeldwaarnemingenEvaluationComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  readonly workspaceId = this.env.TGA_VELDWAARNEMINGEN_DASHBOARD_WORKSPACE_ID;
  readonly reportId = this.env.TGA_VELDWAARNEMINGEN_DASHBOARD_REPORT_ID;
}
